export const localStorageUserKey = 'user';
export const localStorageTokenKey = 'token';

export const authHeader = function () {
    // return authorization header with jwt token
    const token = userToken();

    if (token && token.token) {
        return { Authorization: `Bearer ${token.token}` };
    }
    return {};
};

export const loggedInUser = function () {
    return JSON.parse(localStorage.getItem(localStorageUserKey));
};

export const userToken = function () {
    return JSON.parse(localStorage.getItem(localStorageTokenKey));
};

export const loggedIn = function () {
    return localStorage.getItem(localStorageTokenKey) !== null;
};
